import React from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css";

function SoftwareTesting() {
    return (
        <div className="webdev-page" style={{overflowX:"hidden"}}>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Software Testing </h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Introduction Section */}
            {/* <section className="testing-intro-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="">
                                <h2>Quality Assurance That Drives Confidence</h2>
                                <p>
                                    We offer a comprehensive range of software testing services designed to help businesses deliver high-quality software applications. Our team of experienced testers ensures your software meets all functional and non-functional requirements while identifying and eliminating bugs.
                                </p>
                                <ul className="testing-highlights">
                                    <li><i className="fas fa-check-circle"></i> Reduce software defects by up to 90%</li>
                                    <li><i className="fas fa-check-circle"></i> Cut down development costs through early detection</li>
                                    <li><i className="fas fa-check-circle"></i> Accelerate time-to-market with efficient testing</li>
                                    <li><i className="fas fa-check-circle"></i> Ensure seamless user experiences across platforms</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="testing-intro-image">
                                <div className="testing-graphic">
                                    <div className="circle-element"></div>
                                    <div className="square-element"></div>
                                    <div className="checkmark-element"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="testing-intro-section">
                <div className="container">
                <div className="section-header">
                        <h2 data-aos="fade-up">Quality Assurance That Drives Confidence</h2>
                        <p className="section-description">
                        We provide end-to-end software testing services that help businesses deliver reliable, high-quality applications. Our expert QA team follows rigorous testing methodologies to ensure your software meets functional and non-functional requirements, eliminating bugs and optimizing performance before launch.                        </p>
                    </div>
                </div>
                </section>


            {/* Our Services Section */}
            <section className="webdev-services-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our Testing Services</h2>
                        <p className="section-description">
                            Comprehensive testing solutions to ensure your software is reliable, secure, and user-friendly
                        </p>
                    </div>

                    <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-tasks"></i>
                            </div>
                            <h3>Functional Testing</h3>
                            <p>Verify your application against defined specifications to ensure it functions exactly as intended.</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-robot"></i>
                            </div>
                            <h3>Automated Testing</h3>
                            <p>Leverage advanced tools and frameworks to automate repetitive testing tasks, improving efficiency and accuracy.
</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-shield-alt"></i>
                            </div>
                            <h3>Quality Assurance</h3>
                            <p>Conduct in-depth quality checks to guarantee your software is stable, secure, and production-ready.</p>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-tachometer-alt"></i>
                            </div>
                            <h3>Performance Testing</h3>
                            <p>Test system speed, scalability, and responsiveness under varying loads to identify and resolve bottlenecks.
</p>
                        </div>
                        
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <h3>Mobile Testing</h3>
                            <p>Validate mobile app functionality across multiple devices, screen sizes, and operating systems.
</p>
                        </div>
                        
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-user-check"></i>
                            </div>
                            <h3>Usability Testing</h3>
                            <p>Analyze usability to create a smoother and more satisfying experience for end users.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testing Process Section */}
            <section className="design-process-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our Software Testing Process</h2>
                        <p className="section-description">
                            A structured approach to delivering reliable and high-quality software through rigorous testing
                        </p>
                    </div>

                    <div className="process-timeline">
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Test Planning & Strategy Development</h3>
                                <p>Collaborate to create a tailored test plan and strategy aligned with your goals and software requirements.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>Test Execution & Reporting</h3>
                                <p>Execute test cases systematically, documenting bugs and generating detailed test reports for full visibility.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>Test Automation</h3>
                                <p>Automate repetitive testing scenarios to accelerate delivery timelines while maintaining precision.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>Continuous Integration & Deployment Testing</h3>
                                <p>Continuously test throughout integration and deployment cycles to ensure ongoing reliability.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>Defect Analysis & Resolution</h3>
                                <p>Investigate defects, provide actionable insights, and support development teams for quick resolutions.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">6</div>
                            <div className="step-content">
                                <h3>Final Validation</h3>
                                <p>Validate the final product, ensuring it meets all functional expectations and quality benchmarks</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="design-principles-section">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our Designs</h2>
            <p className="section-description">
              Our design philosophy is built on principles that ensure exceptional user experiences
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
            {[
                {
                    icon: "fas fa-users", 
                    title: "Comprehensive Testing", 
                    text: "Thorough testing across all modules, features, and user flows."
                  },
                  {
                    icon: "fas fa-tachometer-alt", 
                    title: "Reliable Performance", 
                    text: "Software is validated to perform consistently under all scenarios."
                  },
                  {
                    icon: "fas fa-project-diagram", 
                    title: "Seamless Integration", 
                    text: "CI/CD testing ensures stability with every release and update."
                  },
                  {
                    icon: "fas fa-dollar-sign", 
                    title: "Cost Efficiency", 
                    text: "Test automation minimizes costs while increasing testing efficiency."
                  },
                  {
                    icon: "fas fa-file-alt", 
                    title: "Detailed Reporting", 
                    text: "Detailed reports provide actionable insights and clear visibility into quality status."
                  },
                  {
                    icon: "fas fa-life-ring", 
                    title: "Ongoing Support", 
                    text: "Ongoing QA ensures your software evolves in line with business needs and user expectations."
                  }
                
            ].map((feature, idx) => (
              <div className="service-card" key={idx}>
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


            {/* CTA Section */}
            <section className="cta-section mt-5">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Ensure Your Software Quality?</h2>
                        <p>Let our testing experts help you deliver reliable, bug-free software that exceeds user expectations.</p>
                        <a href="/contact" className="cta-button">Get a Free Testing Consultation</a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default SoftwareTesting;
